import React from 'react'

import { Hidden } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PersonIcon from '@material-ui/icons/Person'

import Image from 'artkive/components/Image'
import { NAVIGATION } from 'artkive/constants/tracker/mainNavigation'
import routes from 'artkive/utils/routes'

import ArtkiveGrayscaleLogo from 'images/ecom/home/brands-banner/ArtkiveGrayscaleLogo.svg'
import CardkiveGrayscaleLogo from 'images/ecom/home/brands-banner/CardkiveGrayscaleLogo.svg'
import PhotokiveGrayscaleLogo from 'images/ecom/home/brands-banner/PhotokiveGrayscaleLogo.svg'

import { AccountButton, BrandBannerWrap, BrandLogoButton, BrandsBox } from './BrandsBanner.style'

const useStyles = makeStyles((muiTheme) => ({
  artkiveBrandLogo: {
    width: '80px',
    [muiTheme.breakpoints.up('md')]: {
      width: '96px',
    },
  },
  cardkiveBrandLogo: {
    width: '99px',
    [muiTheme.breakpoints.up('md')]: {
      width: '124px',
    },
  },
  photokiveBrandLogo: {
    width: '104px',
    [muiTheme.breakpoints.up('md')]: {
      width: '132px',
    },
  },
}))

const BrandsBanner = () => {
  const classes = useStyles()

  return (
    <BrandBannerWrap data-testid='brands-banner'>
      {/* empty block for correct layout*/}
      <div></div>
      <BrandsBox>
        <BrandLogoButton href={routes.home} disableRipple>
          <Image src={ArtkiveGrayscaleLogo} className={classes.artkiveBrandLogo} loading='eager' />
        </BrandLogoButton>
        <BrandLogoButton href={routes.cardkive} target='_blank' trackerEvent={NAVIGATION.CARDS_CLICK} disableRipple>
          <Image src={CardkiveGrayscaleLogo} className={classes.cardkiveBrandLogo} loading='eager' />
        </BrandLogoButton>
        <BrandLogoButton
          href={routes.photokive}
          target='_blank'
          trackerEvent={NAVIGATION.PHOTOKIVE_CLICK}
          disableRipple
        >
          <Image src={PhotokiveGrayscaleLogo} className={classes.photokiveBrandLogo} loading='eager' />
        </BrandLogoButton>
      </BrandsBox>
      <Hidden smDown>
        <AccountButton startIcon={<PersonIcon />} href={routes.accountOrders} trackerEvent={NAVIGATION.MY_ORDERS_CLICK}>
          My Account
        </AccountButton>
      </Hidden>
    </BrandBannerWrap>
  )
}

export default BrandsBanner
